import React from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { Layout, Menu } from 'antd';

import { actionCreators } from '../../store'
import { actionCreators as homeActionCreators } from '../../../home/store'
import { forceReloadTo } from '../../../../utils/hardNavigation'
import styles from './index.module.css'

const SideMenu = () => {
    const dispatch = useDispatch()
    let items = useSelector(state => state.get('admin').get('navbar_menu')).toJS()
    let active_navbar = useSelector(state => state.get('admin').get('active_navbar'))

    const onClick = (e) => {
        dispatch(actionCreators.setActiveNavbarAction(e.key))
        dispatch(actionCreators.setKnowledgeBaseShowContentAction(''))
        dispatch(actionCreators.setPermissionUserPageAction('table'))
        dispatch(actionCreators.setPermissionUserUuidAction(''))
        dispatch(actionCreators.setPermissionGroupPageAction('table'))
        dispatch(actionCreators.setPermissionGroupIdAction(''))
    };

    const goToHome = () => {
        dispatch(homeActionCreators.isShowScreenPersonalOverview(true))
        dispatch(homeActionCreators.isShowScreenStoneModelMall(false))
        dispatch(homeActionCreators.isShowScreenPersonalBackpack(false))
        dispatch(homeActionCreators.expertRelatedAction())
        dispatch(actionCreators.resetState())
        forceReloadTo('#/home')
    }

    return (
        <>
            <Layout.Sider
                breakpoint="lg"
                collapsedWidth="0"
                onBreakpoint={(broken) => {
                    console.log(broken);
                }}
                onCollapse={(collapsed, type) => {
                    console.log(collapsed, type);
                }}
            >
                <div className={styles.home}>
                    <div
                        className={styles.home_butn}
                        onClick={goToHome}
                    >
                        Home
                    </div>
                </div>
                <Menu
                    theme="dark"
                    onClick={onClick}
                    selectedKeys={[active_navbar]}
                    mode="inline"
                    items={items}
                />
            </Layout.Sider>
        </>
    );
};

export default SideMenu;
